import React from 'react';

import styles from './Placeholder.module.scss';

const Placeholder = () => (
  <div className={styles.main}>
    <div className={styles.stripe} style={{ width: 148, marginBottom: 8 }} />
    <div className={styles.stripe} style={{ width: 287, marginBottom: 4 }} />
    <div className={styles.stripe} style={{ width: 151, marginBottom: 16 }} />
    <div className={styles.stripe} style={{ width: 74, marginBottom: 8 }} />
  </div>
);

export default Placeholder;
